import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { actionType } from 'utils/constants';
import selectors from 'state/selectors';
import actions from 'state/actions';
import CommonButton from 'components/Buttons/CommonButton';
import utils from 'utils';
import { modalActionType } from 'utils/constants';
import services from 'services';

const UnblockUsers = () => {
  const t = utils.intl.useTranslator();
  const dispatch = useDispatch();
  const selectedUser = useSelector(selectors.configurator.getSelectedUser);

  const onConfirmUnblockUser = async () => {
    dispatch(actions.configurator.setFormMode(null));
    if (selectedUser) {
      try {
        await services.unblockUser({ idUser: selectedUser.idUser });
        utils.app.notify('success', t('user_unblocked_successfully'));
        dispatch(
          actions.configurator.updateTableRows({
            idUsers: [selectedUser].map((e) => e.idUser),
            property: 'blocked',
            value: 0,
          }),
        );
        dispatch(actions.modal.closeModal());
        dispatch(actions.configurator.setSelectedUser(null));
      } catch (e) {
        console.error(e);
      }
    }
  };

  return (
    <CommonButton
      id="unblock-user-btn"
      action={() =>
        dispatch(
          actions.modal.setModal({
            actionType: modalActionType.configurator.UNBLOCK_USER,
            props: {
              subtitle: `${t('are_you_sure_to_unblock')} ${
                selectedUser?.username ? selectedUser.name : t('this_user')
              }?`,
              func: () => onConfirmUnblockUser(),
            },
          }),
        )
      }
      disabled={!(selectedUser && utils.user.isActionByCompanyActive(actionType.BLOCK_USER))}
      scope="tertiary"
      value={t('unblock-user')}
      customIcon="pause"
    />
  );
};

export default UnblockUsers;
